module.exports = __webpack_public_path__ + "img/logo_gmarket.aec60d96.png";